var Files = {};


import SendSignatureRequest from './Files/SendSignatureRequest';
Files.SendSignatureRequest = SendSignatureRequest;
export {SendSignatureRequest};


export default Files;
